export default "__VITE_ASSET__DvOj3L3k__"